import Vue from 'vue';
import App from './App';
import router from './services/router';
import './styles/main.scss';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
});
